import { Action } from 'redux';
import { IGroupInfo } from '../../../ts/models/IGroupInfo';
import { ISiteUserInfo } from '../../../ts/models/ISiteUserInfo';
import { GroupAddUsers, GroupRemoveUsers, SyncAdGroup } from './../AppActionTypes';


export interface GroupUserAddAction extends Action {
  group: IGroupInfo;
}

export function addSiteUsersToGroup(group: IGroupInfo): GroupUserAddAction {
  return {
    type: GroupAddUsers,
    group
  };
}

export interface GroupMenuAction extends Action {
  items: ISiteUserInfo[];
}

export function removeSiteUsersFromGroup(items: ISiteUserInfo[]): GroupMenuAction {
  return {
    type: GroupRemoveUsers,
    items,
  };
}

export interface GroupSyncAction extends Action {
  group: IGroupInfo;
}

export function syncAdGroup(group: IGroupInfo): GroupSyncAction {
  return {
    type: SyncAdGroup,
    group
  };
}
